module.exports = "<p>\r\n  splitpayment works!\r\n</p>\r\n"